import {Translation} from 'primeng/api';

/** JS Date.getDay(): 0 = dimanche … 6 = samedi. Semaine ISO / européenne : lundi en premier. */
const EU_FIRST_DAY_OF_WEEK = 1;

const FR: Partial<Translation> = {
	firstDayOfWeek: EU_FIRST_DAY_OF_WEEK,
	dateFormat: 'dd/mm/yy',
	dayNames: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
	dayNamesShort: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
	dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
	monthNames: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
	monthNamesShort: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
	today: 'Aujourd\'hui',
	clear: 'Effacer',
	weekHeader: 'Sem',
};

const NL: Partial<Translation> = {
	firstDayOfWeek: EU_FIRST_DAY_OF_WEEK,
	dateFormat: 'dd-mm-yy',
	dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
	dayNamesShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
	dayNamesMin: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
	monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
	monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
	today: 'Vandaag',
	clear: 'Wissen',
	weekHeader: 'Wk',
};

const PT: Partial<Translation> = {
	firstDayOfWeek: EU_FIRST_DAY_OF_WEEK,
	dateFormat: 'dd/mm/yy',
	dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
	dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
	dayNamesMin: ['Do', 'Se', 'Te', 'Qa', 'Qi', 'Sx', 'Sa'],
	monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
	monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
	today: 'Hoje',
	clear: 'Limpar',
	weekHeader: 'Sem',
};

const IT: Partial<Translation> = {
	firstDayOfWeek: EU_FIRST_DAY_OF_WEEK,
	dateFormat: 'dd/mm/yy',
	dayNames: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'],
	dayNamesShort: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
	dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
	monthNames: ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'],
	monthNamesShort: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
	today: 'Oggi',
	clear: 'Cancella',
	weekHeader: 'Sett',
};

const LOCALES: Record<string, Partial<Translation>> = {
	FR,
	NL,
	PT,
	IT,
};

export function getAppPrimeTranslation(lang: string | null | undefined): Partial<Translation> {
	const key = (lang || 'FR').toUpperCase();
	return LOCALES[key] ?? FR;
}
